<div class="row pt-2 pb-2 bg-white">
  <div class="col-12">

    <!-- Category ====================================== -->
    <div class="row mt-2">
      <div class="col-12">
        <span class="text-muted fw-bold">
          Category
          <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Select the category for the coupon."
          placement="top"></i-bs>
        </span>

        <button class="btn btn-outline-secondary btn-sm float-end" (click)="showMasterFormModal('category', 'Categories', master_form_modal)">Add</button>
      </div>
      <div class="col-12 mt-2">
        <ng-multiselect-dropdown 
          [disabled]="categorySelectionDisabled"
          [placeholder]="'Select'"
          [settings]="categorySelectionSettings"
          [data]="categories"
          [(ngModel)]="couponDetails.categories"
          (onDeSelect)="onCategoryDeSelect($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>

    <!-- Manufacturer & Brand ====================================== -->
    <div class="row mt-3">
      <div class="col-6">
        <span class="text-muted fw-bold">
          Manufacturer
          <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Select the manufacturer for the coupon."
          placement="top"></i-bs>
        </span>

        <button class="btn btn-outline-secondary btn-sm float-end" (click)="showMasterFormModal('manufacturer', 'Manufacturers', master_form_modal)">Add</button>
      </div>
      <div class="col-6">
        <span class="text-muted fw-bold">
          Brand
          <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Select the brand for the coupon."
          placement="top"></i-bs>
        </span>

        <button class="btn btn-outline-secondary btn-sm float-end" (click)="showMasterFormModal('brand', 'Brands', master_form_modal)">Add</button>
      </div>

      <div class="col-6 mt-2">
        <select class="form-select text-muted" 
          placeholder="Select"
          [(ngModel)]="couponDetails.manufacturer"
          [disabled]="manufacturersLoading === true"
          (change)="onManufacturerChange($event)">
          <option *ngFor="let manufacturer of manufacturers" [ngValue]="manufacturer">{{ manufacturer.mfg_name }}</option>
        </select>
      </div>
      <div class="col-6 mt-2">
        <select class="form-select text-muted" 
          placeholder="Select"
          [(ngModel)]="couponDetails.brand"
          [disabled]="brandsLoading === true">
          <option *ngFor="let brand of brands" [ngValue]="brand">{{ brand.brand_name }}</option>
        </select>
      </div>
    </div>

    <!-- Coupon Types ====================================== -->
    <div class="row mt-3">
      <div class="col-12">
        <span class="text-muted fw-bold">
          Coupon Types
          <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Select type of coupon that you are going to create."
          placement="top"></i-bs>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center" *ngIf="couponTypesLoading">
        <div class="spinner-border text-info mt-4" role="status"></div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-4 text-center" *ngFor="let item of couponTypes">
        <div class="coupon-type-outer">
          <div class="title text-muted">{{ item.discount_type }}</div>
          <div class="sub-title text-muted">{{ item.discount_label }}</div>
          <input class="form-check-input" type="radio" name="coupon_type_chk" [id]="'coupon_type_chk_' + item.discount_id" [value]="item.discount_id" [(ngModel)]="+couponDetails.discount_type_id" (change)="onDiscountTypeChange($event)">
        </div>
      </div>
    </div>

    <!-- Face Value ====================================== -->
    <div class="row mt-3" *ngIf="couponDetails.discount_type_id">
      <!-- Is Alcohol coupon ====================================== -->
      <div class="col-12" *ngIf="couponDetails.discount_type_id == 1">
        <span class="text-muted fw-bold">
          Alcohol Coupon
          <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Select if this is an alcohol coupon"
          placement="top"></i-bs>
        </span>
      </div>

      <div class="col-12 mt-1 mb-3" *ngIf="couponDetails.discount_type_id == 1">
        <div class="form-check form-switch" (change)="onAlcoholCouponTypeClick($event)">
          <input type="checkbox" class="form-check-input" id="is_alcohol_coupon" [checked]="couponDetails?.dollar_discount_compare">
        </div>
      </div>

      <div class="col-12">
        <span class="text-muted fw-bold">
          Face Value
          <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Add value of coupon. For $ discount it is dollar value. For Alcohol coupon it is regular price and offer price. For % discount it is percentage value. For BOGO it is quantity for coupon eligibility."
          placement="top"></i-bs>
        </span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12" *ngIf="couponDetails.discount_type_id == 1 && couponDetails.dollar_discount_compare == 0"> <!-- $ value -->
        <input type="number" class="form-control" id="discount_type_id_1" placeholder="E.g. $1.00" [(ngModel)]="couponDetails.discount_value_lower">
      </div>
      <div class="col-12" *ngIf="couponDetails.discount_type_id == 1 && couponDetails.dollar_discount_compare == 1"> <!-- Alcohol regular and offer $ value -->
        <div class="row">
          <div class="col-2 text-muted mt-2">Regular Price</div>
          <div class="col-2">
            <input type="number" class="form-control" id="discount_type_id_3_lower" placeholder="E.g. $4.99" [(ngModel)]="couponDetails.discount_value_lower">
          </div>
          <div class="col-2 text-muted mt-2">Offer Price</div>
          <div class="col-2">
            <input type="number" class="form-control" id="discount_type_id_3_upper" placeholder="E.g. $3.99" [(ngModel)]="couponDetails.discount_value_upper">
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="couponDetails.discount_type_id == 2"> <!-- % value -->
        <input type="number" class="form-control" id="discount_type_id_2" placeholder="E.g. 25%" [(ngModel)]="couponDetails.discount_value_lower">
      </div>
      <div class="col-12" *ngIf="couponDetails.discount_type_id == 3"> <!-- Buy & get values -->
        <div class="row">
          <div class="col-1 text-muted mt-2">Buy</div>
          <div class="col-2">
            <input type="number" class="form-control" id="discount_type_id_3_lower" placeholder="E.g. 1" [(ngModel)]="couponDetails.discount_value_lower">
          </div>
          <div class="col-1 text-muted mt-2">Get</div>
          <div class="col-2">
            <input type="number" class="form-control" id="discount_type_id_3_upper" placeholder="E.g. 2" [(ngModel)]="couponDetails.discount_value_upper">
          </div>
        </div>
      </div>
    </div>

    <!-- Coupon Title ====================================== -->
    <div class="row mt-4">
      <div class="col-12">
        <span class="text-muted fw-bold">
          Title
          <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Add title of coupon. Max no of characters are 100."
          placement="top"></i-bs>
        </span>

        <input type="text" class="form-control mt-2" id="coupon_title" maxlength="100" placeholder="E.g. Save $1 on Downy Liquid Fabric Conditioner" [(ngModel)]="couponDetails.title">
      </div>
    </div>

    <!-- Coupon Description ====================================== -->
    <div class="row mt-4">
      <div class="col-12">
        <span class="text-muted fw-bold">
          Description
          <i-bs
          name="infoCircle"
          class="text-primary"
          tooltip="Add description of coupon. Max no of characters are 2500."
          placement="top"></i-bs>
        </span>

        <textarea class="form-control mt-2" id="coupon_description" maxlength="2500" rows="5" placeholder="E.g. Terms & Conditions..." [(ngModel)]="couponDetails.description"></textarea>
      </div>
    </div>

    <!-- Coupon Image ====================================== -->
    <div class="row mt-4">
      <div class="col-12">
        <span class="text-muted fw-bold">
          Image
          <i-bs
            name="infoCircle"
            class="text-primary"
            tooltip="Add image for coupon. Max file size is 50 Kb. File types supported are png & jpg."
            placement="top">
          </i-bs>
        </span>

        &nbsp;<div class="spinner-grow spinner-grow-sm text-secondary" role="status" *ngIf="couponImageUploading"></div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <ngx-dropzone [multiple]="false" (change)="onImageSelect($event)"> <!-- accept="image/jpeg,image/jpg,image/png" [maxFileSize]="50000" -->
          <ngx-dropzone-label>Click or Drag & Drop your coupon image here <br> Files supported - png & jpeg <br> Max file size 50 Kb</ngx-dropzone-label>
          <ngx-dropzone-preview *ngFor="let imageFile of couponImageFiles" [removable]="true" (removed)="onImageRemove(imageFile)">
            <ngx-dropzone-label>{{ imageFile.name }} ({{ imageFile.type }})</ngx-dropzone-label>
          </ngx-dropzone-preview>

          <!--<ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let imageFile of couponImageFiles" [file]="imageFile">
            <ngx-dropzone-label>{{ imageFile.name }} ({{ imageFile.type }})</ngx-dropzone-label>
          </ngx-dropzone-image-preview>-->
        </ngx-dropzone>
      </div>
      <div class="col-6" *ngIf="couponDetails?.uploadedImage">
        <img class="img-preview" [src]="couponDetails?.uploadedImage">
      </div>
    </div>


    <!-- Next/Previuos Buttons -->
    <div class="row mt-3 pt-3 mb-0 border-top">
      <div class="col-6">

      </div>
      <div class="col-6 text-end">
        <button type="button" class="btn btn-secondary text-white fw-bold" title="Select Products" (click)="onNavigationClick('previous')">
          <i-bs class="text-light" name="arrowLeft" width="22" height="22"></i-bs>
        </button>
        &nbsp;
        <button type="button" class="btn btn-secondary text-white fw-bold" title="Select Retailers" (click)="onNavigationClick('next')">
          <i-bs class="text-light" name="arrowRight" width="22" height="22"></i-bs>
        </button>
      </div>
    </div>

  </div>
</div>


<!-- Master form Modal -->
<ng-template #master_form_modal>
  <div class="modal-header">
    <h6 class="modal-title text-muted float-start">{{ masterFormModalData.title }}</h6>

    <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideMasterFormModal()"></i-bs>
  </div>

  <div class="modal-body">
    <app-manage-category module='RETAILER' *ngIf="masterFormModalData.mode == 'category'" (actions)="masterFormActions('category', $event)"></app-manage-category>

    <app-manage-manufacturer module='RETAILER' *ngIf="masterFormModalData.mode == 'manufacturer'" (actions)="masterFormActions('manufacturer', $event)"></app-manage-manufacturer>

    <app-manage-brand module='RETAILER' *ngIf="masterFormModalData.mode == 'brand'" (actions)="masterFormActions('brand', $event)"></app-manage-brand>
  </div>
</ng-template>